module.exports = __webpack_public_path__ + "src/assets/img/musicbox-slot.3c640d40.png";